import { Navigate } from 'react-router-dom';
export default function Reports() { return <Navigate to="/reports/hub" replace />; }
